export let hasToastLoaded = false;

export const resetToast = () => (hasToastLoaded = false);
